var map = {
	"./add-user.svg": 64841,
	"./arrow-down.svg": 35206,
	"./arrow-left.svg": 52973,
	"./arrow-right.svg": 29520,
	"./arrow-up.svg": 43037,
	"./arrow.svg": 23369,
	"./ballpen.svg": 3366,
	"./bar-graph.svg": 11962,
	"./building.svg": 83758,
	"./calendar-check.svg": 78187,
	"./caret-down.svg": 63512,
	"./caret-right.svg": 68786,
	"./chat-gpt.svg": 4676,
	"./check-green.svg": 83888,
	"./check-red.svg": 44624,
	"./check.svg": 68866,
	"./close.svg": 75102,
	"./collapse.svg": 50819,
	"./delete.svg": 88795,
	"./document.svg": 14969,
	"./download-arrow.svg": 12734,
	"./download.svg": 2410,
	"./expand.svg": 84286,
	"./file-upload.svg": 51798,
	"./filter.svg": 42848,
	"./full-arrow-down.svg": 28742,
	"./full-arrow-up.svg": 55005,
	"./help.svg": 6691,
	"./info.svg": 95890,
	"./key.svg": 93431,
	"./layers.svg": 8584,
	"./light-bulb.svg": 19518,
	"./like.svg": 27047,
	"./mail-closed.svg": 16712,
	"./mail-in.svg": 72021,
	"./mail-out.svg": 11276,
	"./mailbox.svg": 50334,
	"./menu.svg": 4147,
	"./message.svg": 37439,
	"./messages.svg": 94078,
	"./microsoft-teams.svg": 15267,
	"./minus.svg": 8094,
	"./mobile-phone.svg": 83431,
	"./more.svg": 56085,
	"./phone.svg": 89458,
	"./plus.svg": 44598,
	"./print.svg": 95227,
	"./robot-happy.svg": 26475,
	"./robot.svg": 46950,
	"./save.svg": 18433,
	"./screen-profile.svg": 29674,
	"./search.svg": 7650,
	"./settings.svg": 38993,
	"./shut-down.svg": 5533,
	"./slack-black.svg": 7560,
	"./slack-colorful.svg": 47557,
	"./smiley.svg": 18443,
	"./sparkles.svg": 42403,
	"./star-full.svg": 21800,
	"./star.svg": 62610,
	"./translate.svg": 51748,
	"./triangle-down.svg": 34699,
	"./triangle-up.svg": 87172,
	"./user-pass.svg": 22863,
	"./user.svg": 24339,
	"./users.svg": 82874,
	"./warning.svg": 72054,
	"./wemply.svg": 18712,
	"./x-red.svg": 37708,
	"./yester.svg": 75572
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 62165;